import { CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import {
  isCreate,
  isPartial,
  isTL,
  load,
  resetOfferStore,
} from '@store/orders';
import { createEffect, createMemo, on, onCleanup, Show } from 'solid-js';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { FeatureFlags } from '@constants/featureFlags';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';

import { getLoadOffers, invalidateLoadOffersRequests } from './helpers';
import { OfferHistory } from './OfferHistory';
import { MyOffers } from './MyOffers';

export const CarrierOffers = (props: {
  loading?: boolean;
  changeTrackingSource?: ChangeTrackingSource;
}) => {
  const isVoid = createMemo(() => load()?.status === 'Void');

  createEffect(
    on(
      () => [load()?.id, isVoid()] as const,
      ([loadId]) => {
        if (loadId) {
          void getLoadOffers(loadId);
        } else {
          invalidateLoadOffersRequests();
          resetOfferStore();
        }
      },
    ),
  );

  onCleanup(invalidateLoadOffersRequests);

  return (
    <Show
      when={
        isFeatureFlagEnabled(FeatureFlags.OfferDetails)() &&
        (isTL() || isPartial()) &&
        !isCreate()
      }
    >
      <CollapsibleCard
        startTitle="Carrier Offers"
        loading={props.loading}
        class="mb-2"
      >
        <div class="flex flex-col gap-4">
          <Show when={isFeatureFlagEnabled(FeatureFlags.MyOffers)()}>
            <MyOffers changeTrackingSource={props.changeTrackingSource} />
          </Show>
          <OfferHistory changeTrackingSource={props.changeTrackingSource} />
        </div>
      </CollapsibleCard>
    </Show>
  );
};
